export const possibleEquipmentYears = ()=>{
    const today = new Date();
    let resuls = [];
    for (let i = today.getFullYear()+1 ; i > today.getFullYear()-25; i--){
        resuls.push(i)
    }
    return resuls;
}

export function generateRandomString(length) {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    return result;
}
export function dateFormatter(input){
    const possibleDates = input.match(/((^|\s)\d{4}([.\-/])\d{1,2}([.\-/])\d{1,2}($|\s))|((^|\s)\d{1,2}([.\-/])\d{1,2}([.\-/])(\d{4}|\d{2})($|\s))|(^|\s)(\d{1,2}([.\-/])\d{1,2}($|\s))/g);
    
    function formatDate(string){
        let yearNotSpecified = false;
        let year, month, day;
        string = string.trim();
        function twoDigitFormat (str){
            if(str.length === 1){
                return '0'+str;
            }else if (str.length === 4){
                return str.substr(2)
            }
            return str;
        }
        const divider = string.replace(/[0-9]/g, '').charAt(0);
        const arrayForm = string.split(divider);
        if(arrayForm.length === 2){
            month = twoDigitFormat(arrayForm[0]);
            day = twoDigitFormat(arrayForm[1]);
            year = ((new Date()).getFullYear()).toString().substring(2);
            yearNotSpecified = true;
        }else if(arrayForm[0].length === 4){
            year = arrayForm[0].substr(2);
            month = twoDigitFormat(arrayForm[1]);
            day = twoDigitFormat(arrayForm[2]);
        }else if(arrayForm[2].length === 1){
            year = arrayForm[0];
            month = twoDigitFormat(arrayForm[1]);
            day = twoDigitFormat(arrayForm[2]);
        }else{
            month = twoDigitFormat(arrayForm[0]);
            day = twoDigitFormat(arrayForm[1]);
            year = arrayForm[2].length === 4 ? arrayForm[2].substr(2):arrayForm[2];
        }
        if(month < 1 || month > 12)return null;
        if(day < 1 || day > 31)return null;
        
        return {datePart: day < 29 || isValidDate_MMDDYY(month, day, year) ? `${month}/${day}/${year}` : null,
                "yearNotSpecified": yearNotSpecified};
    }
    function isValidDate_MMDDYY(month, day, year) {
        if (!month || !day || !year) return false;
        const date = new Date(year, month - 1, day);
        return (
            date.getFullYear() % 100  === parseInt(year) &&
            date.getMonth() === parseInt(month - 1) &&
            date.getDate() === parseInt(day)
        );
    }
    const ReturnObject = {
        date:null,
        time:null,
        yearNotSpecified: null
    }
    if (possibleDates !== null){
        for (let date of possibleDates){
            if(ReturnObject.date === null){
                const obj = formatDate(date);
                if(obj){
                    const fomrattedDate = obj.datePart;
                    if (fomrattedDate !== null)
                    {
                        ReturnObject.yearNotSpecified = obj.yearNotSpecified;
                        ReturnObject.date = fomrattedDate;
                    }
                }
            }
            const s = input.substr(0, input.indexOf(date));
            const e = input.substr(input.indexOf(date) + date.length)
            input = s + e; 
        }
    }
    ReturnObject.time = timeFormatter(input) !== null? timeFormatter(input).time : null;
    return ReturnObject;
}


export function timeFormatter(input){
    const dates = input.match(/(\d{1,4}([.\-/])\d{1,2}([.\-/])\d{1,4})/g);
    if (dates !== null){
        for (let i of dates){
            const s = input.substr(0, input.indexOf(i));
            const e = input.substr(input.indexOf(i) + i.length)
            input = s + e; 
        }
    }
    if (!input) return {date: null,time: null};
      
    // Remove all spaces around dashes
    input = input.replace(/\s*-\s*/g, "-").trim();
    const parts = input.includes("-") ? input.split("-") : [input];
    let formattedParts = parts.map(parseSingleTime);
    formattedParts = formattedParts.filter(item => item !== null);
    if(formattedParts.length === 0)return {date: null,time: null};
    if(formattedParts.length > 1){
        const firstTime = new Date("1970-01-01 "+formattedParts[0]);
        const secondTime = new Date("1970-01-01 "+formattedParts[1]);
        if (secondTime < firstTime) {
            formattedParts = [formattedParts[1]];
        }
    }
    return {
        date: null,
        time: formattedParts.length > 1 ? `${formattedParts[0]} - ${formattedParts[1]}` : formattedParts[0]
    };
}
function parseSingleTime(timeStr) {
    timeStr = timeStr.trim().toUpperCase();

  // Already valid 12-hour time like "08:30 AM"
    const full12HourMatch = /^(0?[1-9]|1[0-2]):[0-5][0-9]\s?(AM|PM)$/.exec(timeStr);
    if (full12HourMatch) {
        // eslint-disable-next-line
        const [_, hour, minute, period] = timeStr.match(/^(\d{1,2}):(\d{2})\s?(AM|PM)$/i);
        return `${hour.padStart(2, "0")}:${minute} ${period}`;
    }

    // Handle "7 AM", "12PM", etc.
    const shorthandMatch = /^(\d{1,2})\s?(AM|PM)$/.exec(timeStr);
    if (shorthandMatch) {
        const hour = shorthandMatch[1];
        const period = shorthandMatch[2];
        if (parseInt(hour) >= 1 && parseInt(hour) <= 12) {
            return `${hour.padStart(2, "0")}:00 ${period}`;
        }
        return null;
    }
    // Handle plain hour like "7" or "15"
    if (/^\d{1,2}$/.test(timeStr)) {
        let hour = parseInt(timeStr, 10);
        if (hour > 23) return null;

        const period = hour >= 12 ? "PM" : "AM";
        const hour12 = hour % 12 || 12;

        return `${String(hour12).padStart(2, "0")}:00 ${period}`;
    }

    // Handle numeric input like 800, 0800, 2330
    const digitsOnly = timeStr.replace(/[^0-9]/g, "");
    if (!/^\d{3,4}$/.test(digitsOnly)) return null;

    let hour = parseInt(digitsOnly.length === 3 ? digitsOnly.slice(0, 1) : digitsOnly.slice(0, 2), 10);
    let minute = parseInt(digitsOnly.length === 3 ? digitsOnly.slice(1) : digitsOnly.slice(2), 10);

    if (hour > 23 || minute > 59) return null;

    const period = hour >= 12 ? "PM" : "AM";
    const hour12 = hour % 12 || 12;

    return `${String(hour12).padStart(2, "0")}:${String(minute).padStart(2, "0")} ${period}`;
}
export const isValidZip = (val)=>{
    const US_TEST_RES = val.match(/\d{5}(-\d{4})?/g);
    const  CANADA_TEST_RES = val.match(/[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ ]?\d[ABCEGHJ-NPRSTV-Z]\d/g);
    if (US_TEST_RES !== null){
        return US_TEST_RES[0];
    }else if (CANADA_TEST_RES !== null){
        return CANADA_TEST_RES[0];
    }
    return false;
}
export const isValidState = (val) => {
    const STATE_OR_PROVINCE = val.trim().toLowerCase().replaceAll(' ', '').match(/alabama|alaska|arizona|arkansas|california|colorado|connecticut|delaware|florida|georgia|hawaii|idaho|illinois|indiana|iowa|kansas|kentucky|louisiana|maine|maryland|massachusetts|michigan|minnesota|mississippi|missouri|montana|nebraska|nevada|newhampshire|newjersey|newmexico|newyork|northcarolina|northdakota|ohio|oklahoma|oregon|pennsylvania|rhodeisland|southcarolina|southdakota|tennessee|texas|utah|virginia|vermont|washington|westvirginia|wisconsin|wyoming|québec|quebec|ontario|britishcolumbia|manitoba|newbrunswick|saskatchewan|newfoundland|novascotia|alberta|yukon|northwestterritories|nunavut|princeedwardisland|al|ak|az|ar|ca|co|ct|de|fl|ga|hi|id|il|in|ia|ks|ky|la|me|md|ma|mi|mn|ms|mo|mt|ne|nv|nh|nj|nm|ny|nc|nd|oh|ok|or|pa|ri|sc|sd|tn|tx|ut|vt|va|wa|wv|wi|wy|nl|pe|ns|nb|qc|on|mb|sk|ab|bc|wt|nt|dc|nu/g);
    function abbrState(input, to){
        var states = [
            ['arizona', 'AZ'], ['alabama', 'AL'],['alaska', 'AK'],['arkansas', 'AR'],['california', 'CA'],['colorado', 'CO'],['connecticut', 'CT'],['delaware', 'DE'],['florida', 'FL'],['georgia', 'GA'],['hawaii', 'HI'],['idaho', 'ID'],['illinois', 'IL'],['indiana', 'IN'],['iowa', 'IA'],['kansas', 'KS'],['kentucky', 'KY'],['louisiana', 'LA'],['maine', 'ME'],['maryland', 'MD'],['massachusetts', 'MA'],['michigan', 'MI'],['minnesota', 'MN'],['mississippi', 'MS'],['missouri', 'MO'],['montana', 'MT'],['nebraska', 'NE'],['nevada', 'NV'],['newhampshire', 'NH'],['newjersey', 'NJ'],['newmexico', 'NM'],['newyork', 'NY'],['northcarolina', 'NC'],['northdakota', 'ND'],['ohio', 'OH'],['oklahoma', 'OK'],['oregon', 'OR'],['pennsylvania', 'PA'],['rhodeisland', 'RI'],['southcarolina', 'SC'],['southdakota', 'SD'],['tennessee', 'TN'],['texas', 'TX'],['utah', 'UT'],['vermont', 'VT'],['virginia', 'VA'],['washington', 'WA'],['westvirginia', 'WV'],['wisconsin', 'WI'],['wyoming', 'WY'],['alberta','AB'],['québec','QC'],['quebec','QC'],['saskatchewan','SK'],['manitoba','MB'],['ontario','ON'],['britishcolumbia','BC'],['northwestterritories','NT'],['yukon','YT'],['novascotia','NS'],['princeedwardisland','PE'],['nunavut','NU'],['newfoundland','NL'],['newbrunswick','NB'],['district of columbia','DC']
        ];
    
        if (to === 'abbr'){
            for(let i = 0; i < states.length; i++){
                if(states[i][0] === input){
                    return(states[i][1]);
                }
            } 
            return false;
        }
    }
    if (STATE_OR_PROVINCE === null || STATE_OR_PROVINCE[0] === '')return false;
    if(STATE_OR_PROVINCE[0].length > 2){
        return abbrState(STATE_OR_PROVINCE[0],'abbr');
    }else{
        return STATE_OR_PROVINCE[0].toUpperCase();
    }
    
}
export const phoneNumberTyping = (val) =>{
    return val.replace(/[^- ()+0-9]/g,'');
}
export const isValidPhoneNumber = (val, target) =>{
    const NUMBERS = val.match(/^(\+\d{1,2}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/g);
    if (NUMBERS){
        let phoneNumber = NUMBERS[0];
        phoneNumber =  phoneNumber.replace('+1', '');
        phoneNumber = phoneNumber.replace(/[^0-9]/g,'');
        return `(${phoneNumber.substr(0, 3)}) ${phoneNumber.substr(3, 3)}-${phoneNumber.substr(6, 4)}`
    }else{
        target.style.color = 'var(--alert-color)';
        setTimeout(() => {
            target.style.color = '';
            target.value = "";
        }, 500);
        
        return "INVALID INPUT";
    }    
}
export const isValidEmailAddress = (val, target) => {
    const EMAIL = val.match(/^[\w-.]+@([\w-]+.)+[\w-]{2,4}$/g);
    if(EMAIL){
        return EMAIL[0];
    }else{
        target.style.color = 'var(--alert-color)';
        setTimeout(() => {
            target.style.color = '';
            target.value = "";
        }, 500);
        
        return "INVALID INPUT";
    }
}
export const cityNameFormatter = (val) => {
    const arr = val.toLowerCase().split(" ");
    let res = "";
    for (const word of arr){
        res +=  `${word.charAt(0).toUpperCase() + word.slice(1)} `;
    }
    return res.trim();
}

export function generateShortId(length = 8) {
    return Math.random().toString(36).substring(2, 2 + length);
}